export default __webpack_public_path__ + "static/media/Resume-RoseLandroche.abcbd8b5.pdf";